import { render, staticRenderFns } from "./paroki.vue?vue&type=template&id=0498b4f3&"
import script from "./paroki.vue?vue&type=script&lang=js&"
export * from "./paroki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports